import { CanvasBaseObject } from './canvas-base-object';

export class CanvasRectangle extends CanvasBaseObject {
  constructor(
    id: number,
    x: number,
    y: number,
    width: number,
    height: number,
    public oneTime: boolean = false,
    public scaleFactor?: number,
  ) {
    super(id, x, y, width, height);
  }
}
